var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Flex } from '..';
import { useChocoModalContext } from './context';
const largeChocoModalContentContainerStyles = {
    overflow: 'hidden',
    height: '100%',
    flexDirection: 'column',
    p: 'm',
};
const smallChocoModalContainerStyles = {
    flexDirection: 'column',
    p: 'xxl',
};
const ChocoModalContainer = (_a) => {
    var { children, width } = _a, props = __rest(_a, ["children", "width"]);
    const { size } = useChocoModalContext();
    const styles = size === 'small'
        ? smallChocoModalContainerStyles
        : largeChocoModalContentContainerStyles;
    return (_jsx(Flex, Object.assign({}, props, { sx: Object.assign(Object.assign({}, styles), { width }) }, { children: children })));
};
export default ChocoModalContainer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2hvY29Nb2RhbENvbnRhaW5lci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL2NvbW1vbnMvQ2hvY29Nb2RhbC9DaG9jb01vZGFsQ29udGFpbmVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7QUFFQSxPQUFPLEVBQUUsSUFBSSxFQUFhLE1BQU0sSUFBSSxDQUFDO0FBRXJDLE9BQU8sRUFBRSxvQkFBb0IsRUFBRSxNQUFNLFdBQVcsQ0FBQztBQUVqRCxNQUFNLHFDQUFxQyxHQUF1QjtJQUNoRSxRQUFRLEVBQUUsUUFBUTtJQUNsQixNQUFNLEVBQUUsTUFBTTtJQUNkLGFBQWEsRUFBRSxRQUFRO0lBQ3ZCLENBQUMsRUFBRSxHQUFHO0NBQ1AsQ0FBQztBQUVGLE1BQU0sOEJBQThCLEdBQXVCO0lBQ3pELGFBQWEsRUFBRSxRQUFRO0lBQ3ZCLENBQUMsRUFBRSxLQUFLO0NBQ1QsQ0FBQztBQVFGLE1BQU0sbUJBQW1CLEdBQUcsQ0FBc0MsRUFJcEMsRUFBZSxFQUFFO1FBSm1CLEVBQ2hFLFFBQVEsRUFDUixLQUFLLE9BRXVCLEVBRHpCLEtBQUssY0FId0QscUJBSWpFLENBRFM7SUFFUixNQUFNLEVBQUUsSUFBSSxFQUFFLEdBQUcsb0JBQW9CLEVBQUUsQ0FBQztJQUV4QyxNQUFNLE1BQU0sR0FDVixJQUFJLEtBQUssT0FBTztRQUNkLENBQUMsQ0FBQyw4QkFBOEI7UUFDaEMsQ0FBQyxDQUFDLHFDQUFxQyxDQUFDO0lBRTVDLE9BQU8sQ0FDTCxLQUFDLElBQUksb0JBQ0MsS0FBSyxJQUNULEVBQUUsa0NBQ0csTUFBTSxLQUNULEtBQUssbUJBR04sUUFBUSxJQUNKLENBQ1IsQ0FBQztBQUNKLENBQUMsQ0FBQztBQUVGLGVBQWUsbUJBQW1CLENBQUMifQ==